import { useLocation } from 'react-router-dom';
import { ROUTES } from '../../../shared/config/routes';

export function useReturnLocation() {
  const location = useLocation();
  // Where the user came from (templates list, cadences, …), captured on entry.
  // Falls back to the templates list when there's no origin in state (e.g. a
  // direct URL or a fresh entry that didn't pass `from`).
  return location.state?.from ?? ROUTES.TEMPLATES;
}
